export default __webpack_public_path__ + "static/media/author2.cfa464f9.jpg";